import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const EyeClosedIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Eye Closed`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1.25 13.25 12-12"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.842 3.597C10.745 2.837 9.435 2.25 8 2.25c-2.241 0-4.176 1.433-5.477 2.716A16.74 16.74 0 0 0 .377 7.582l-.008.013-.003.004v.002H.364a.75.75 0 0 0 0 .797L1 8a61.48 61.48 0 0 0-.635.4h.001l.003.005.008.013a6.253 6.253 0 0 0 .146.22 16.737 16.737 0 0 0 2 2.396c.3.295.632.598.993.889l1.068-1.068a11.6 11.6 0 0 1-1.007-.889A15.24 15.24 0 0 1 1.907 8a15.24 15.24 0 0 1 1.67-1.966C4.81 4.817 6.375 3.75 8 3.75c.96 0 1.899.373 2.761.928l1.081-1.081ZM9.106 6.333a2 2 0 0 0-2.773 2.773l2.773-2.773ZM7.601 9.96 9.96 7.6A2 2 0 0 1 7.6 9.96Zm-1.728 1.728c.68.347 1.398.562 2.127.562 1.625 0 3.19-1.067 4.423-2.284A15.234 15.234 0 0 0 14.093 8a15.234 15.234 0 0 0-1.67-1.966c-.15-.148-.304-.293-.462-.434l1.062-1.062c.159.143.31.286.454.428a16.736 16.736 0 0 1 2.146 2.616l.008.013.003.004.001.002a.751.751 0 0 1 0 .798l-.001.002-.003.004-.008.013a10.164 10.164 0 0 1-.146.22 16.733 16.733 0 0 1-2 2.396C12.175 12.317 10.24 13.75 8 13.75c-1.178 0-2.271-.396-3.232-.957l1.105-1.105ZM1 8l-.635-.398.126.079L1 8Z"
      clipRule="evenodd"
    />
  </Icon>
);
